/* Dossier PDP — product.dossier template only.
   Spec-table variant sync, selected-variant line, pill scroll-spy.
   No-ops on every other template. */
(function () {
  var root = document.querySelector('.theme-template-suffix-dossier');
  if (!root) return;

  // Clamped chapter bodies: the Liquid guard is only a character-count floor,
  // so drop the clamp wherever the text already fits. Re-checked on resize
  // because the same copy overflows on a phone and fits on a desktop.
  function measureClamps() {
    document.querySelectorAll('.dossier-chapter__body-wrap').forEach(function (wrap) {
      var clamp = wrap.querySelector('.dossier-clamp, .dossier-clamp--fits');
      var btn = wrap.querySelector('.dossier-clamp__btn');
      if (!clamp || !btn) return;
      // measure against the clamped state, never while expanded
      if (clamp.classList.contains('dossier-clamp--open')) return;
      clamp.classList.add('dossier-clamp');
      clamp.classList.remove('dossier-clamp--fits');
      var overflows = clamp.scrollHeight > clamp.clientHeight + 2;
      btn.hidden = !overflows;
      if (!overflows) {
        clamp.classList.remove('dossier-clamp');
        clamp.classList.add('dossier-clamp--fits');
      }
    });
  }

  function initClamps() {
    measureClamps();
    // a late webfont swap can change the verdict
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measureClamps).catch(function () {});
    }
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measureClamps, 150);
    });
  }

  // Chapter heads whose content is decided client-side, not by Liquid.
  //
  // "Pieces You've Looked At" is driven by localStorage, so on a visitor's very
  // first product page the recently-viewed section hides itself and the heading
  // was left standing over nothing. "More Pieces Like This" has the same shape:
  // the recommendations endpoint can come back empty for a product with no
  // related items. Liquid cannot know either at render time.
  //
  // So the head follows whatever section sits directly after it: if that section
  // renders no height, the head hides too.
  var CONDITIONAL_HEADS = ['dossier-ch-7', 'dossier-ch-8'];

  function syncConditionalHeads() {
    CONDITIONAL_HEADS.forEach(function (anchorId) {
      var anchor = document.getElementById(anchorId);
      if (!anchor) return;
      var head = anchor.closest('.shopify-section');
      if (!head) return;
      var content = head.nextElementSibling;
      while (content && !content.classList.contains('shopify-section')) {
        content = content.nextElementSibling;
      }
      if (!content) return;
      // Measure the tallest visible child, not the wrapper: .x-section carries
      // its own 32px padding, so a section whose children are all display:none
      // still reports 64px and would read as populated.
      var maxChild = 0;
      for (var i = 0; i < content.children.length; i++) {
        var kid = content.children[i];
        if (kid.offsetParent !== null && kid.offsetHeight > maxChild) {
          maxChild = kid.offsetHeight;
        }
      }
      var empty = content.offsetParent === null || maxChild < 40;
      head.classList.toggle('dossier-head--empty', empty);
    });
  }

  function initConditionalHeads() {
    syncConditionalHeads();
    // Both sections populate asynchronously: recently-viewed waits for Alpine to
    // read localStorage, recommendations wait on a fetch. Watch for the DOM
    // settling rather than guessing at a delay.
    var observer = new MutationObserver(function () {
      clearTimeout(observer._t);
      observer._t = setTimeout(syncConditionalHeads, 60);
    });
    CONDITIONAL_HEADS.forEach(function (anchorId) {
      var anchor = document.getElementById(anchorId);
      var head = anchor && anchor.closest('.shopify-section');
      var content = head && head.nextElementSibling;
      if (content) {
        observer.observe(content, { childList: true, subtree: true, attributes: true,
                                    attributeFilter: ['style', 'class', 'hidden'] });
      }
    });
    window.addEventListener('load', syncConditionalHeads);
  }

  // Judge.me's preview badge emits AggregateRating microdata that is not
  // nested in any Product node — Google reads it as an orphan ("missing
  // itemReviewed", ERROR) and fails the page's product snippets. The theme's
  // ProductGroup JSON-LD is the sole schema owner, so strip the microdata
  // attributes from the badge (visible stars untouched). Runs regardless of
  // the app's own rich-snippets setting; see the JudgeMe fix handoff.
  function neutralizeBadgeMicrodata() {
    document.querySelectorAll('.jdgm-prev-badge__rich-snippet, .jdgm-prev-badge__rich-snippet [itemprop]')
      .forEach(function (el) {
        el.removeAttribute('itemprop');
        el.removeAttribute('itemscope');
        el.removeAttribute('itemtype');
      });
  }

  function init() {
    neutralizeBadgeMicrodata();
    // Clamping is independent of the product form — run it before the form
    // guard below, or a missing form would silently leave short bodies
    // clamped behind a dead button.
    initClamps();
    initConditionalHeads();

    // NOTE: the theme's main-product section closes <main> early (pre-existing
    // quirk), so dossier chapter sections live OUTSIDE .theme-template-suffix-dossier
    // in the corrected DOM — query document-wide, guarded by the root check above.
    var form = document.querySelector('.main-product form[id^="product-form-"]');
    if (!form) return;
    // form.id is shadowed by the hidden <input name="id"> inside the form
    var sectionId = form.getAttribute('id').replace('product-form-', '');

    function syncVariant(variant) {
      if (!variant) return;
      // spec tables: show only the selected variant's table
      var tables = document.querySelectorAll('[data-spec-variant-id]');
      tables.forEach(function (t) {
        t.hidden = String(variant.id) !== t.dataset.specVariantId;
        // x-collapse pins an inline height on the open panel and never resets
        // it to auto. Variants carry different row counts, so a taller table
        // would spill past the panel. Release the pin and let it re-measure.
        var panel = t.closest('.dossier-acc__content');
        if (panel && panel.style.height && panel.style.height !== '0px') {
          panel.style.height = 'auto';
        }
      });
      // "Selected: Walnut float, 18x24" confirmation line
      var line = document.querySelector('[data-dossier-selected]');
      if (line) {
        var parts = variant.options || (variant.title ? variant.title.split(' / ') : []);
        line.innerHTML = parts.length
          ? 'Selected: <strong>' + parts.join(', ').replace(/</g, '&lt;') + '</strong>'
          : '';
      }
    }

    document.addEventListener('eurus:product-card-variant-select:updated:' + sectionId, function (e) {
      syncVariant(e.detail && e.detail.currentVariant);
    });

    // initial state from the selected-variant JSON the picker already embeds
    var seed = root.querySelector('.variant-selects-main script[type="application/json"][data-selected-variant]');
    if (seed) {
      try { syncVariant(JSON.parse(seed.textContent)); } catch (err) { /* leave server-rendered default */ }
    }

    // pill scroll-spy
    var pills = document.querySelectorAll('.dossier-pills a[href^="#"]');
    if (pills.length && 'IntersectionObserver' in window) {
      var byId = {};
      pills.forEach(function (p) { byId[p.getAttribute('href').slice(1)] = p; });
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && byId[entry.target.id]) {
            pills.forEach(function (p) { p.classList.remove('dossier-pill--on'); });
            byId[entry.target.id].classList.add('dossier-pill--on');
          }
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      Object.keys(byId).forEach(function (id) {
        var el = document.getElementById(id);
        if (el) observer.observe(el);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
